<div class="w-100 h-100 d-flex flex-column overflow-hidden">
  @if (customer && fileName) {
    <div class="data-view-dialog-title">
      <h5>
        {{ customer.replace("_", " ") | titlecase }} -
        {{ fileName.replace("_", " ") | titlecase }}
      </h5>
      <hr />
    </div>
  }
  @if (loading) {
    <div
      class="d-flex justify-content-center align-items-center"
      style="min-height: 350px"
    >
      <mat-spinner></mat-spinner>
    </div>
  }
  @if (!loading && fileStats && fileData?.length > 0) {
    <div
      class="d-flex flex-column w-100 h-100"
      style="max-height: calc(100% - 3rem)"
    >
      @if (hasFileStats) {
        <div class="d-flex flex-wrap justify-content-between px-2 pt-2 pb-4">
          @for (stat of fileStatKeys; track stat) {
            <div class="filestat">
              <span class="filestat-key"
                >{{ stat.split("_").join(" ") | titlecase }}:</span
              >
              {{ fileStats[stat] }}
            </div>
          }
        </div>
      }
      @if (fileData?.length > 0) {
        <div
          class="ps-2 w-100 d-flex flex-column overflow-hidden"
          style="max-height: calc(100% - 2rem)"
        >
          @if (!enableSorting) {
            <mat-table
              [dataSource]="dataSource"
              class="w-100 h-100 overflow-auto"
            >
              @for (column of displayedColumns; track column) {
                @if (column !== "actions") {
                  <ng-container [matColumnDef]="column">
                    <th mat-header-cell *matHeaderCellDef>
                      <div>{{ column }}</div>
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element; let idx = index"
                      [ngStyle]="
                        getBackgroundColorForCell(column, element[column])
                      "
                      [ngClass]="getColumnClass(column, element)"
                    >
                      @if (column !== "select") {
                        <div>{{ element[column] }}</div>
                      } @else {
                        <div class="checkbox-cell">
                          <mat-checkbox
                            #checkbox="matCheckbox"
                            [id]="'checkbox' + idx"
                            [checked]="element[column]"
                            (change)="onSelect(idx, $event)"
                            (click)="$event.stopPropagation()"
                            [disabled]="readOnly"
                          >
                          </mat-checkbox>
                        </div>
                      }
                    </td>
                  </ng-container>
                }
              }
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="actions-menu"></th>
                <td
                  mat-cell
                  *matCellDef="let element; let idx = index"
                  class="actions-menu"
                >
                  <div
                    class="d-flex justify-content-center align-items-center gap-2"
                  >
                    <i
                      class="fas fa-undo"
                      [class.disabled]="readOnly || isEmpty(element)"
                      [attr.disabled]="
                        readOnly || isEmpty(element) ? true : null
                      "
                      (click)="!readOnly && !isEmpty(element) && onUndo(idx)"
                    ></i>
                  </div>
                </td>
              </ng-container>
              <tr
                mat-header-row
                *matHeaderRowDef="loading ? [] : displayedColumns; sticky: true"
              ></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: loading ? [] : displayedColumns"
              ></tr>
            </mat-table>
          }
          @if (enableSorting) {
            <mat-table
              [dataSource]="dataSource"
              matMultiSort
              class="w-100 h-100 overflow-auto"
            >
              @for (column of displayedColumns; track column) {
                @if (column !== "actions") {
                  <ng-container [matColumnDef]="column">
                    <th
                      mat-header-cell
                      *matHeaderCellDef
                      [mat-multi-sort-header]="column"
                    >
                      <div>{{ column }}</div>
                    </th>
                    <td
                      mat-cell
                      *matCellDef="let element; let idx = index"
                      [ngStyle]="
                        getBackgroundColorForCell(column, element[column])
                      "
                      [ngClass]="getColumnClass(column, element)"
                    >
                      @if (column !== "select") {
                        <div>{{ element[column] }}</div>
                      } @else {
                        <div class="checkbox-cell">
                          <mat-checkbox
                            #checkbox="matCheckbox"
                            [id]="'checkbox' + idx"
                            [checked]="element[column]"
                            (change)="onSelect(idx, $event)"
                            (click)="$event.stopPropagation()"
                            [disabled]="readOnly"
                          >
                          </mat-checkbox>
                        </div>
                      }
                    </td>
                  </ng-container>
                }
              }
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef class="actions-menu"></th>
                <td
                  mat-cell
                  *matCellDef="let element; let idx = index"
                  class="actions-menu"
                >
                  <div
                    class="d-flex justify-content-center align-items-center gap-2"
                  >
                    <i
                      class="fas fa-undo"
                      [class.disabled]="readOnly || isEmpty(element)"
                      [attr.disabled]="
                        readOnly || isEmpty(element) ? true : null
                      "
                      (click)="!readOnly && !isEmpty(element) && onUndo(idx)"
                    ></i>
                  </div>
                </td>
              </ng-container>
              <tr
                mat-header-row
                *matHeaderRowDef="loading ? [] : displayedColumns; sticky: true"
              ></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: loading ? [] : displayedColumns"
              ></tr>
            </mat-table>
          }
          <mat-paginator
            [pageSize]="defaultPageSize"
            [showFirstLastButtons]="showFirstLastButtons"
            [pageSizeOptions]="pageOptions"
            [disabled]="!displayedColumns.length"
            aria-label="Select page"
          >
          </mat-paginator>
        </div>
      }
    </div>
  }
</div>
